import { UIHeading2, UIText1, UIHeading1, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { EDeviceType } from '../../types/device';

export interface IErrorComponentProps {
  deviceType: EDeviceType;
  onClick: () => void;
}

export const ErrorComponent: React.FC<IErrorComponentProps> = ({ deviceType, onClick }) => {
  const header =
    deviceType === EDeviceType.Desktop ? <UIHeading1>Избранное</UIHeading1> : <UIHeading2>Избранное</UIHeading2>;

  return (
    <div className={styles['container']} data-testid="error-component">
      <div className={styles['header']}>{header}</div>
      <div className={styles['content']}>
        <div className={styles['image']}></div>
        <UIHeading2>Что-то пошло не так</UIHeading2>
        <UIText1>Попробуйте обновить или зайдите чуть позже</UIText1>
        <Button onClick={onClick} size="L">
          Обновить
        </Button>
      </div>
    </div>
  );
};
